import { render, staticRenderFns } from "./headerIcon.vue?vue&type=template&id=51de58de"
import script from "./headerIcon.vue?vue&type=script&lang=js"
export * from "./headerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports